export enum UndoState {
    Succeeded,
    Failed,
    Unchainged,
}